import { createContext, useContext } from "react";
import type { PortalSubscriptionProvider } from "@/types/center";

interface SubscriptionContextValue {
  status: string | null;
  billingCadence?: "monthly" | "annual";
  provider?: PortalSubscriptionProvider | null;
  nextBillingDate: string | null;
  expiredOn: string | null;
  portalUrl: string | null;
  tierQuantity: number;
  subscriptionId: string | null;
  isSubscriptionActive: boolean;
  isLoading: boolean;
  gymName: string;
  email: string;
  isBillingOwner: boolean;
  billedThroughCenterName: string;
  timezone: string | null;
  trialEndDate: string | null;
  seenReferralModal: boolean;
}

export const SubscriptionContext = createContext<SubscriptionContextValue | null>(
  null,
);

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (!context)
    throw new Error("useSubscription must be used within SubscriptionProvider");
  return context;
};
